import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const pains = ['Historia clínica armada en papel porque "la mía no era legal para Argentina"', 'Consentimientos copiados de internet que no cumplen la Ley 26.529', 'Protocolos de HTA, DBT2 y celiaquía en tres carpetas distintas que nunca encontrás', 'El paciente pregunta por creatina y buscás en Google mientras sonreís con cara de "ya lo sé"', 'El "¿y yo qué como?" sin respuesta clara todos los viernes a las 11 de la noche', 'Fin de semana agotado. El lunes, el mismo ciclo.'];
  return <section className="py-14 px-4 max-w-4xl mx-auto pt-[5px] pb-[5px] space-y-[0px]" data-id="element-204">
      <FadeIn data-id="element-205">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6" data-id="element-206">
          ¿Cuántos domingos más vas a perder así?
        </h2>

        <div className="text-lg md:text-xl text-gray-300 text-center mb-10 space-y-4 max-w-3xl mx-auto" data-id="element-207">
          <p data-id="element-208">
            Amás lo que hacés. Pero nadie te dijo que ibas a pasar los domingos
            armando formularios desde cero, buscando recetas que no encajan y
            redactando planes para patologías que ya conocés de memoria.
          </p>
          <p className="font-bold text-white text-2xl mt-8" data-id="element-209">
            No es falta de vocación.{' '}
            <span className="text-red-400" data-id="element-210">Es falta de un sistema.</span>
          </p>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-211">
        <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-10 shadow-lg" data-id="element-212">
          <ul className="space-y-6" data-id="element-213">
            {pains.map((pain, index) => <li key={index} className="flex gap-4 items-start" data-id="element-214">
                <XCircle className="text-red-500 shrink-0 mt-1" size={24} data-id="element-215" />
                <span className="text-gray-300 text-lg" data-id="element-216">{pain}</span>
              </li>)}
          </ul>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-217">
        <div className="text-center mt-14" data-id="element-218">
          <h3 className="text-3xl md:text-4xl font-bold text-green-400" data-id="element-219">
            ¿Y si este fuera el último domingo que pasó así?
          </h3>
        </div>
      </FadeIn>
    </section>;
}